import React, { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import { Button } from 'react-admin'

import { lightergray3, black } from '../../constants/colorConstants'
import ThreeDots from '../../images/threeDots'

const useStyles = makeStyles((theme) => ({
  menuVisible: {
    position: 'absolute',
    right: '10px',
    zIndex: 101,
    background: lightergray3,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
    padding: '10px',
  },
  screenVisible: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'transparent',
    zIndex: 100,
  },
  invisible: {
    display: 'none',
  },
  optionButton: {
    width: '100%',
    fontSize: '13px',
    lineHeight: '22px',
    ...theme.mundi.font.roboto400Normal,
    color: black,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  optionButtonContent: {
    width: '100%',
  },
  button: {
    paddingLeft: '30px',
    paddingRight: '30px',
    cursor: 'pointer',
  },
}))

export const DropdownButton = ({
  buttonProps,
  items,
  onOptionClick,
  className,
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(false)

  const handleExpand = () => {
    setExpanded(true)
  }

  const handleCollapse = () => {
    setExpanded(false)
  }

  const handleOptionClick = (i, item) => {
    if (onOptionClick) onOptionClick(i, item)
    setExpanded(false)
  }

  return (
    <div className={className}>
      <div
        {...buttonProps}
        className={`${classes.button} ${buttonProps?.className}`}
        onClick={handleExpand}
        role="button"
        tabIndex={0}
      >
        <ThreeDots />
      </div>
      <div
        role="button"
        tabIndex={0}
        className={expanded ? classes.screenVisible : classes.invisible}
        onClick={handleCollapse}
      />
      <div className={expanded ? classes.menuVisible : classes.invisible}>
        {items?.map((item, i) => (
          <div className={classes.optionButtonContent} key={`dialogButton${i}`}>
            <Button
              className={classes.optionButton}
              key={`dropdownButton${i}`}
              onClick={() => handleOptionClick(i, item)}
              label={item}
            />
          </div>
        ))}
      </div>
    </div>
  )
}
